import { create } from 'zustand'

import type { IProfile } from 'types/interfaces/IProfile'
import { useLocalStorageAccessToken } from 'utils'

interface AuthStore {
    accessToken: string
    setAccessToken: (accessToken: string) => void

    userProfile: IProfile | null
    setUserProfile: (userProfile: Partial<IProfile>) => void

    isLoggingOut: boolean
    setIsLoggingOut: (isLoggingOut: boolean) => void
}

export const useAuthStore = create<AuthStore>()(set => ({
    accessToken: useLocalStorageAccessToken(),

    setAccessToken: (accessToken: string) => {
        set({ accessToken })
    },

    userProfile: null,

    setUserProfile: (userProfile: Partial<IProfile>) => {
        set(state => ({
            userProfile: state.userProfile
                ? { ...state.userProfile, ...userProfile }
                : (userProfile as IProfile)
        }))
    },

    isLoggingOut: false,

    setIsLoggingOut: (isLoggingOut: boolean) => {
        set({ isLoggingOut })
    }
}))

export const useAccessToken = () => useLocalStorageAccessToken()

export const useSetAccessToken = (accessToken: string) => {
    useAuthStore.getState().setAccessToken(accessToken)
}

export const useUserProfile = () =>
    useAuthStore(state => state.userProfile)

export const useSetUserProfile = (userProfile: Partial<IProfile>) => {
    useAuthStore.getState().setUserProfile(userProfile)
}

export const useIsLoggingOut = () =>
    useAuthStore(state => state.isLoggingOut)

export const useSetIsLoggingOut = (isLoggingOut: boolean) => {
    useAuthStore.getState().setIsLoggingOut(isLoggingOut)
}